import React from "react";
import { TableCell, TableSortLabel } from "@mui/material";
import TableHeader from "@crema/core/AppTable/TableHeader";
import { ContactMasterData } from "types/models/contactMaster/ContactMasterApp";

interface TableHeadingProps {
  order: "asc" | "desc";
  orderBy: keyof ContactMasterData;
  onSort: (property: keyof ContactMasterData) => void;
}

const commonCellStyle = {
  fontSize: 14,
  width: 200,
  maxWidth: 180,
  minWidth: 160,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
};

const headCells: { id: keyof ContactMasterData; label: string }[] = [
  { id: "createdAt", label: "Date" },
  { id: "source", label: "Source" },
  { id: "reference", label: "Reference" },
  { id: "name", label: "Name" },
  { id: "contactNo", label: "Mobile" },
  { id: "email", label: "Email" },
  { id: "city", label: "City" },
  { id: "message", label: "Remarks" },
];

const TableHeading: React.FC<TableHeadingProps> = ({ order, orderBy, onSort }) => {
  const createSortHandler = (property: keyof ContactMasterData) => () => {
    onSort(property);
  };

  return (
    <TableHeader>
      {headCells.map((headCell) => (
        <TableCell
          key={headCell.id}
          sx={commonCellStyle}
          sortDirection={orderBy === headCell.id ? order : false}
        >
          <TableSortLabel
            active={orderBy === headCell.id}
            direction={orderBy === headCell.id ? order : "asc"}
            onClick={createSortHandler(headCell.id)}
          >
            {headCell.label}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableHeader>
  );
};

export default TableHeading;
